<template>
	<div class="about">
		<div class="column-wrap">
			<div class="column-title">
				<div class="column-t1">
					问题汇集
				</div>
				<div class="column-t2">
					您是否也碰到了下面类似的问题？
				</div>
			</div>
			<div class="column-box">
				<div class="problem-img">
					<img src="../assets/page3.png" alt="">
				</div>
			</div>
		</div>
			
			
		<div class="column-wrap">
			<div class="column-title">
				<div class="column-t1">
					适用案例
				</div>
				<div class="column-t2">
					以下案例运用物联云可轻松解决如下问题
				</div>
			</div>
			<div class="column-box">
				<div class="man-custom">
					<swiper :options="swiperOption1" ref="mySwiper" style="width: 65%;">
						<swiper-slide>
							<div class="swiper-icon">
								<img src="../assets/cart/solutioncaselogo.png" alt="">
							</div>
							<div class="swiper-title">
								某珠宝翡翠行
							</div>
							<div class="swiper-content">
								某珠宝翡翠行每天耗费大量人力时间清点货物，但仍然无法
								实时了解门店每天的销售情况、库存情况，
								无法为经营决策提供有效的数据支撑；面对商品人工出货的时候
								无法保障准确性，无法提高出货核对效率。
							</div>
						</swiper-slide>
						<swiper-slide>
							<div class="swiper-icon">
								<img src="../assets/cart/solutioncaselogo.png" alt="">
							</div>
							<div class="swiper-title">
								某珠宝翡翠行
							</div>
							<div class="swiper-content">
								某珠宝翡翠行每天耗费大量人力时间清点货物，但仍然无法
								实时了解门店每天的销售情况、库存情况，
								无法为经营决策提供有效的数据支撑；面对商品人工出货的时候
								无法保障准确性，无法提高出货核对效率。
							</div>
						</swiper-slide>
					</swiper>
					<div class="swiper-button-prev swiper-button-prev1" slot="button-prev1"></div>
					<div class="swiper-button-next swiper-button-next1" slot="button-next1"></div>
				</div>
			</div>
		</div>	
			
		<div class="column-wrap">
			<div class="column-title">
				<div class="column-t1">
					解决流程
				</div>
				<div class="column-t2">
					专业的团队提供专业行业解决方案
				</div>
			</div>
			<div class="column-box">
				<div class="cart-box clearfix">
					<div class="cart-list ">
						<div class="cart-img">
							<img src="../assets/cart/solutionprocess1.png" alt="">
						</div>
						<div class="cart-text">
							专家咨询
							精准匹配
						</div>
					</div>
					
					<div class="cart-list">
						<div class="cart-img">
							<img src="../assets/cart/solutionprocess2.png" alt="">
						</div>
						<div class="cart-text">
							行业需求
							详细沟通
						</div>
					</div>
					<div class="cart-list">
						<div class="cart-img">
							<img src="../assets/cart/solutionprocess3.png" alt="">
						</div>
						<div class="cart-text">
							方案推荐
							量身打造
						</div>
					</div>
					
					<div class="cart-line l1">
						<img src="../assets/cart/solutionprocess4.png" alt="">
					</div>
					<div class="cart-line l2">
						<img src="../assets/cart/solutionprocess4.png" alt="">
					</div>
				</div>
			</div>
		</div>	

		<div class="column-wrap">
			<div class="column-title">
				<div class="column-t1">
					解决方案特点
				</div>
			</div>
			<div class="column-box">
				<div class="solve-box clearfix">
					<div class="solve-list fl">
						<div class="solve-img">
							<img src="../assets/cart/solutionprocess5.png" alt="">
						</div>
						<div class="solve-text">
							<div>
								RFID技术和传统标签的完美结合
							</div>
							<div>
								真正做到一物一码，实现精准跟踪和管理
							</div>
						</div>
					</div>
					<div class="solve-list fl">
						<div class="solve-img">
							<img src="../assets/cart/solutionprocess6.png" alt="">
						</div>
						<div class="solve-text">
							<div>
								数据无缝对接,适用多平台接口
							</div>
							<div>
								盘点数据、库存数据、进销存数据
							</div>
						</div>
					</div>
					<div class="solve-list fl">
						<div class="solve-img">
							<img src="../assets/cart/solutionprocess7.png" alt="">
						</div>
						<div class="solve-text">
							<div>
								蓝牙RFID拍与APP设备的完美结合
							</div>
							<div>
								可以查库存、看搭配，轻松营销
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>	


	</div>
</template>

<script>
	export default{
		data(){
			return{
				swiperOption1:{
					slidesPerView: 1,
					loop: true,
					spaceBetween: 30,
					centeredSlides: true,
					navigation: {
						nextEl: '.swiper-button-next1',
						prevEl: '.swiper-button-prev1',
					}
				},
			}
		},
		mounted(){
			this.tabs('tabBox');
		},
		methods:{
			swiper(){
				return this.$refs.mySwiper.swiper;
			}
		}
	}
</script>

<style scoped>
@import url("../resource/css/about.css");

</style>



// WEBPACK FOOTER //
// src/components/about.vue